import { Routes } from '@angular/router';
import { MainLayout } from './layout/main-layout/main-layout';
import { authGuard } from './core/guards/auth.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    // ログイン画面（MainLayout 配下ではない＝ヘッダー/サイドバーなし）
    path: 'login',
    loadComponent: () => import('./features/login/login').then((m) => m.Login),
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'master/register',
        loadComponent: () =>
          import('./features/master-register/master-register').then((m) => m.MasterRegister),
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'master/edit/:id',
        loadComponent: () =>
          import('./features/master-register/master-register').then((m) => m.MasterRegister),
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'master/check',
        loadComponent: () =>
          import('./features/master-check/master-check').then((m) => m.MasterCheck),
      },
      {
        path: 'category/register',
        loadComponent: () =>
          import('./features/category-register/category-register').then((m) => m.CategoryRegister),
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'category/edit/:id',
        loadComponent: () =>
          import('./features/category-register/category-register').then((m) => m.CategoryRegister),
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'category/check',
        loadComponent: () =>
          import('./features/category-check/category-check').then((m) => m.CategoryCheck),
      },
      {
        path: 'category/filter',
        loadComponent: () =>
          import('./features/category-filter/category-filter').then((m) => m.CategoryFilter),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
